import React from 'react';
import Styles from './ToyotaRavfore.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const Ravfore = () => {
  return (
    
     <div className={Styles.main_page}>
     <h2>Toyota Rav4</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
    <Hero selectedCar="Toyota Rav4" />
   </div>
  );
}

export default Ravfore;
